/* tslint:disable */
/* eslint-disable */
/**
 * BuLLy documentation
 * BuLLy Server
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@redcare-pharmacy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setBearerAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, BaseAPI, operationServerMap } from '../base';
/**
 * CartControllerV2Api - axios parameter creator
 * @export
 */
export const CartControllerV2ApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Endpoint to delete the existing cart, if it exists
         * @param {string} tenant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartV2TenantDelete: (tenant_1, ...args_1) => __awaiter(this, [tenant_1, ...args_1], void 0, function* (tenant, options = {}) {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('cartV2TenantDelete', 'tenant', tenant);
            const localVarPath = `/cart/v2/{tenant}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} tenant
         * @param {string} hashedToken
         * @param {string} Accept_Language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartV2TenantEntriesERxHashedTokenDelete: (tenant_1, hashedToken_1, Accept_Language_1, ...args_1) => __awaiter(this, [tenant_1, hashedToken_1, Accept_Language_1, ...args_1], void 0, function* (tenant, hashedToken, Accept_Language, options = {}) {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('cartV2TenantEntriesERxHashedTokenDelete', 'tenant', tenant);
            // verify required parameter 'hashedToken' is not null or undefined
            assertParamExists('cartV2TenantEntriesERxHashedTokenDelete', 'hashedToken', hashedToken);
            // verify required parameter 'Accept_Language' is not null or undefined
            assertParamExists('cartV2TenantEntriesERxHashedTokenDelete', 'Accept_Language', Accept_Language);
            const localVarPath = `/cart/v2/{tenant}/entries/eRx/{hashedToken}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"hashedToken"}}`, encodeURIComponent(String(hashedToken)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (Accept_Language != null) {
                localVarHeaderParameter['Accept-Language'] = String(Accept_Language);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * create or update eRx entries providing eRx hashedTokens
         * @param {string} tenant
         * @param {string} Accept_Language
         * @param {Array<string>} request_body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartV2TenantEntriesERxPost: (tenant_1, Accept_Language_1, request_body_1, ...args_1) => __awaiter(this, [tenant_1, Accept_Language_1, request_body_1, ...args_1], void 0, function* (tenant, Accept_Language, request_body, options = {}) {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('cartV2TenantEntriesERxPost', 'tenant', tenant);
            // verify required parameter 'Accept_Language' is not null or undefined
            assertParamExists('cartV2TenantEntriesERxPost', 'Accept_Language', Accept_Language);
            // verify required parameter 'request_body' is not null or undefined
            assertParamExists('cartV2TenantEntriesERxPost', 'request_body', request_body);
            const localVarPath = `/cart/v2/{tenant}/entries/eRx`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            if (Accept_Language != null) {
                localVarHeaderParameter['Accept-Language'] = String(Accept_Language);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(request_body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * replace eRx entry providing eRx hashedTokens and preferred pzn
         * @param {string} tenant
         * @param {string} Accept_Language
         * @param {CartV2TenantEntriesERxReplacePutRequest} CartV2TenantEntriesERxReplacePutRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartV2TenantEntriesERxReplacePut: (tenant_1, Accept_Language_1, CartV2TenantEntriesERxReplacePutRequest_1, ...args_1) => __awaiter(this, [tenant_1, Accept_Language_1, CartV2TenantEntriesERxReplacePutRequest_1, ...args_1], void 0, function* (tenant, Accept_Language, CartV2TenantEntriesERxReplacePutRequest, options = {}) {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('cartV2TenantEntriesERxReplacePut', 'tenant', tenant);
            // verify required parameter 'Accept_Language' is not null or undefined
            assertParamExists('cartV2TenantEntriesERxReplacePut', 'Accept_Language', Accept_Language);
            // verify required parameter 'CartV2TenantEntriesERxReplacePutRequest' is not null or undefined
            assertParamExists('cartV2TenantEntriesERxReplacePut', 'CartV2TenantEntriesERxReplacePutRequest', CartV2TenantEntriesERxReplacePutRequest);
            const localVarPath = `/cart/v2/{tenant}/entries/eRx/replace`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            if (Accept_Language != null) {
                localVarHeaderParameter['Accept-Language'] = String(Accept_Language);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(CartV2TenantEntriesERxReplacePutRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * create multiple cartEntries
         * @param {string} tenant
         * @param {string} Accept_Language
         * @param {CartV2CartEntriesRequestV1} CartV2CartEntriesRequestV1
         * @param {boolean} [purgeMessages]
         * @param {string} [nowZipCode]
         * @param {boolean} [isNowSelected]
         * @param {string} [slotId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartV2TenantEntriesPost: (tenant_1, Accept_Language_1, CartV2CartEntriesRequestV1_1, purgeMessages_1, nowZipCode_1, isNowSelected_1, slotId_1, ...args_1) => __awaiter(this, [tenant_1, Accept_Language_1, CartV2CartEntriesRequestV1_1, purgeMessages_1, nowZipCode_1, isNowSelected_1, slotId_1, ...args_1], void 0, function* (tenant, Accept_Language, CartV2CartEntriesRequestV1, purgeMessages, nowZipCode, isNowSelected, slotId, options = {}) {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('cartV2TenantEntriesPost', 'tenant', tenant);
            // verify required parameter 'Accept_Language' is not null or undefined
            assertParamExists('cartV2TenantEntriesPost', 'Accept_Language', Accept_Language);
            // verify required parameter 'CartV2CartEntriesRequestV1' is not null or undefined
            assertParamExists('cartV2TenantEntriesPost', 'CartV2CartEntriesRequestV1', CartV2CartEntriesRequestV1);
            const localVarPath = `/cart/v2/{tenant}/entries`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (purgeMessages !== undefined) {
                localVarQueryParameter['purgeMessages'] = purgeMessages;
            }
            if (nowZipCode !== undefined) {
                localVarQueryParameter['nowZipCode'] = nowZipCode;
            }
            if (isNowSelected !== undefined) {
                localVarQueryParameter['isNowSelected'] = isNowSelected;
            }
            if (slotId !== undefined) {
                localVarQueryParameter['slotId'] = slotId;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            if (Accept_Language != null) {
                localVarHeaderParameter['Accept-Language'] = String(Accept_Language);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(CartV2CartEntriesRequestV1, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} tenant
         * @param {string} offerId
         * @param {string} Accept_Language
         * @param {string} prescriptionType
         * @param {string} [nowZipCode]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        cartV2TenantEntryOfferIdDelete: (tenant_1, offerId_1, Accept_Language_1, prescriptionType_1, nowZipCode_1, ...args_1) => __awaiter(this, [tenant_1, offerId_1, Accept_Language_1, prescriptionType_1, nowZipCode_1, ...args_1], void 0, function* (tenant, offerId, Accept_Language, prescriptionType, nowZipCode, options = {}) {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('cartV2TenantEntryOfferIdDelete', 'tenant', tenant);
            // verify required parameter 'offerId' is not null or undefined
            assertParamExists('cartV2TenantEntryOfferIdDelete', 'offerId', offerId);
            // verify required parameter 'Accept_Language' is not null or undefined
            assertParamExists('cartV2TenantEntryOfferIdDelete', 'Accept_Language', Accept_Language);
            // verify required parameter 'prescriptionType' is not null or undefined
            assertParamExists('cartV2TenantEntryOfferIdDelete', 'prescriptionType', prescriptionType);
            const localVarPath = `/cart/v2/{tenant}/entry/{offerId}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"offerId"}}`, encodeURIComponent(String(offerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (prescriptionType !== undefined) {
                localVarQueryParameter['prescriptionType'] = prescriptionType;
            }
            if (nowZipCode !== undefined) {
                localVarQueryParameter['nowZipCode'] = nowZipCode;
            }
            if (Accept_Language != null) {
                localVarHeaderParameter['Accept-Language'] = String(Accept_Language);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * create or update cartEntry
         * @param {string} tenant
         * @param {string} Accept_Language
         * @param {CartV2CartEntryRequestV1} CartV2CartEntryRequestV1
         * @param {boolean} [purgeMessages]
         * @param {string} [nowZipCode]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        cartV2TenantEntryPost: (tenant_1, Accept_Language_1, CartV2CartEntryRequestV1_1, purgeMessages_1, nowZipCode_1, ...args_1) => __awaiter(this, [tenant_1, Accept_Language_1, CartV2CartEntryRequestV1_1, purgeMessages_1, nowZipCode_1, ...args_1], void 0, function* (tenant, Accept_Language, CartV2CartEntryRequestV1, purgeMessages, nowZipCode, options = {}) {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('cartV2TenantEntryPost', 'tenant', tenant);
            // verify required parameter 'Accept_Language' is not null or undefined
            assertParamExists('cartV2TenantEntryPost', 'Accept_Language', Accept_Language);
            // verify required parameter 'CartV2CartEntryRequestV1' is not null or undefined
            assertParamExists('cartV2TenantEntryPost', 'CartV2CartEntryRequestV1', CartV2CartEntryRequestV1);
            const localVarPath = `/cart/v2/{tenant}/entry`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (purgeMessages !== undefined) {
                localVarQueryParameter['purgeMessages'] = purgeMessages;
            }
            if (nowZipCode !== undefined) {
                localVarQueryParameter['nowZipCode'] = nowZipCode;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            if (Accept_Language != null) {
                localVarHeaderParameter['Accept-Language'] = String(Accept_Language);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(CartV2CartEntryRequestV1, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * replace cartEntry
         * @param {string} tenant
         * @param {string} Accept_Language
         * @param {CartV2CartReplaceEntryRequestV1} CartV2CartReplaceEntryRequestV1
         * @param {boolean} [purgeMessages]
         * @param {string} [nowZipCode]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        cartV2TenantEntryReplacePost: (tenant_1, Accept_Language_1, CartV2CartReplaceEntryRequestV1_1, purgeMessages_1, nowZipCode_1, ...args_1) => __awaiter(this, [tenant_1, Accept_Language_1, CartV2CartReplaceEntryRequestV1_1, purgeMessages_1, nowZipCode_1, ...args_1], void 0, function* (tenant, Accept_Language, CartV2CartReplaceEntryRequestV1, purgeMessages, nowZipCode, options = {}) {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('cartV2TenantEntryReplacePost', 'tenant', tenant);
            // verify required parameter 'Accept_Language' is not null or undefined
            assertParamExists('cartV2TenantEntryReplacePost', 'Accept_Language', Accept_Language);
            // verify required parameter 'CartV2CartReplaceEntryRequestV1' is not null or undefined
            assertParamExists('cartV2TenantEntryReplacePost', 'CartV2CartReplaceEntryRequestV1', CartV2CartReplaceEntryRequestV1);
            const localVarPath = `/cart/v2/{tenant}/entry/replace`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (purgeMessages !== undefined) {
                localVarQueryParameter['purgeMessages'] = purgeMessages;
            }
            if (nowZipCode !== undefined) {
                localVarQueryParameter['nowZipCode'] = nowZipCode;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            if (Accept_Language != null) {
                localVarHeaderParameter['Accept-Language'] = String(Accept_Language);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(CartV2CartReplaceEntryRequestV1, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get new or existing cart for customer (including guests)
         * @param {string} tenant
         * @param {string} Accept_Language
         * @param {boolean} [purgeMessages]
         * @param {string} [nowZipCode]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        cartV2TenantGet: (tenant_1, Accept_Language_1, purgeMessages_1, nowZipCode_1, ...args_1) => __awaiter(this, [tenant_1, Accept_Language_1, purgeMessages_1, nowZipCode_1, ...args_1], void 0, function* (tenant, Accept_Language, purgeMessages, nowZipCode, options = {}) {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('cartV2TenantGet', 'tenant', tenant);
            // verify required parameter 'Accept_Language' is not null or undefined
            assertParamExists('cartV2TenantGet', 'Accept_Language', Accept_Language);
            const localVarPath = `/cart/v2/{tenant}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (purgeMessages !== undefined) {
                localVarQueryParameter['purgeMessages'] = purgeMessages;
            }
            if (nowZipCode !== undefined) {
                localVarQueryParameter['nowZipCode'] = nowZipCode;
            }
            if (Accept_Language != null) {
                localVarHeaderParameter['Accept-Language'] = String(Accept_Language);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Provides information about the cart data
         * @param {string} tenant
         * @param {string} Accept_Language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartV2TenantMetadataGet: (tenant_1, Accept_Language_1, ...args_1) => __awaiter(this, [tenant_1, Accept_Language_1, ...args_1], void 0, function* (tenant, Accept_Language, options = {}) {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('cartV2TenantMetadataGet', 'tenant', tenant);
            // verify required parameter 'Accept_Language' is not null or undefined
            assertParamExists('cartV2TenantMetadataGet', 'Accept_Language', Accept_Language);
            const localVarPath = `/cart/v2/{tenant}/metadata`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (Accept_Language != null) {
                localVarHeaderParameter['Accept-Language'] = String(Accept_Language);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get new or existing cart for customer (including guests) - miniature format
         * @param {string} tenant
         * @param {string} Accept_Language
         * @param {boolean} [disableRefresh]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        cartV2TenantMinicartGet: (tenant_1, Accept_Language_1, disableRefresh_1, ...args_1) => __awaiter(this, [tenant_1, Accept_Language_1, disableRefresh_1, ...args_1], void 0, function* (tenant, Accept_Language, disableRefresh, options = {}) {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('cartV2TenantMinicartGet', 'tenant', tenant);
            // verify required parameter 'Accept_Language' is not null or undefined
            assertParamExists('cartV2TenantMinicartGet', 'Accept_Language', Accept_Language);
            const localVarPath = `/cart/v2/{tenant}/minicart`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (disableRefresh !== undefined) {
                localVarQueryParameter['disableRefresh'] = disableRefresh;
            }
            if (Accept_Language != null) {
                localVarHeaderParameter['Accept-Language'] = String(Accept_Language);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Updates the collectiveOrder or prescriptionFollows status for the customer (including guests)
         * @param {string} tenant
         * @param {string} Accept_Language
         * @param {CartV2TenantPutRequest} CartV2TenantPutRequest
         * @param {string} [nowZipCode]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        cartV2TenantPut: (tenant_1, Accept_Language_1, CartV2TenantPutRequest_1, nowZipCode_1, ...args_1) => __awaiter(this, [tenant_1, Accept_Language_1, CartV2TenantPutRequest_1, nowZipCode_1, ...args_1], void 0, function* (tenant, Accept_Language, CartV2TenantPutRequest, nowZipCode, options = {}) {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('cartV2TenantPut', 'tenant', tenant);
            // verify required parameter 'Accept_Language' is not null or undefined
            assertParamExists('cartV2TenantPut', 'Accept_Language', Accept_Language);
            // verify required parameter 'CartV2TenantPutRequest' is not null or undefined
            assertParamExists('cartV2TenantPut', 'CartV2TenantPutRequest', CartV2TenantPutRequest);
            const localVarPath = `/cart/v2/{tenant}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (nowZipCode !== undefined) {
                localVarQueryParameter['nowZipCode'] = nowZipCode;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            if (Accept_Language != null) {
                localVarHeaderParameter['Accept-Language'] = String(Accept_Language);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(CartV2TenantPutRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} tenant
         * @param {string} Accept_Language
         * @param {boolean} [purgeMessages]
         * @param {string} [nowZipCode]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        cartV2TenantRedpointsDelete: (tenant_1, Accept_Language_1, purgeMessages_1, nowZipCode_1, ...args_1) => __awaiter(this, [tenant_1, Accept_Language_1, purgeMessages_1, nowZipCode_1, ...args_1], void 0, function* (tenant, Accept_Language, purgeMessages, nowZipCode, options = {}) {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('cartV2TenantRedpointsDelete', 'tenant', tenant);
            // verify required parameter 'Accept_Language' is not null or undefined
            assertParamExists('cartV2TenantRedpointsDelete', 'Accept_Language', Accept_Language);
            const localVarPath = `/cart/v2/{tenant}/redpoints`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (purgeMessages !== undefined) {
                localVarQueryParameter['purgeMessages'] = purgeMessages;
            }
            if (nowZipCode !== undefined) {
                localVarQueryParameter['nowZipCode'] = nowZipCode;
            }
            if (Accept_Language != null) {
                localVarHeaderParameter['Accept-Language'] = String(Accept_Language);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} tenant
         * @param {string} Accept_Language
         * @param {CartV2RedPointsRequestV1} CartV2RedPointsRequestV1
         * @param {boolean} [purgeMessages]
         * @param {string} [nowZipCode]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        cartV2TenantRedpointsPost: (tenant_1, Accept_Language_1, CartV2RedPointsRequestV1_1, purgeMessages_1, nowZipCode_1, ...args_1) => __awaiter(this, [tenant_1, Accept_Language_1, CartV2RedPointsRequestV1_1, purgeMessages_1, nowZipCode_1, ...args_1], void 0, function* (tenant, Accept_Language, CartV2RedPointsRequestV1, purgeMessages, nowZipCode, options = {}) {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('cartV2TenantRedpointsPost', 'tenant', tenant);
            // verify required parameter 'Accept_Language' is not null or undefined
            assertParamExists('cartV2TenantRedpointsPost', 'Accept_Language', Accept_Language);
            // verify required parameter 'CartV2RedPointsRequestV1' is not null or undefined
            assertParamExists('cartV2TenantRedpointsPost', 'CartV2RedPointsRequestV1', CartV2RedPointsRequestV1);
            const localVarPath = `/cart/v2/{tenant}/redpoints`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (purgeMessages !== undefined) {
                localVarQueryParameter['purgeMessages'] = purgeMessages;
            }
            if (nowZipCode !== undefined) {
                localVarQueryParameter['nowZipCode'] = nowZipCode;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            if (Accept_Language != null) {
                localVarHeaderParameter['Accept-Language'] = String(Accept_Language);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(CartV2RedPointsRequestV1, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} tenant
         * @param {string} Accept_Language
         * @param {CartV2VoucherRequestV1} CartV2VoucherRequestV1
         * @param {boolean} [purgeMessages]
         * @param {string} [nowZipCode]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        cartV2TenantVoucherPost: (tenant_1, Accept_Language_1, CartV2VoucherRequestV1_1, purgeMessages_1, nowZipCode_1, ...args_1) => __awaiter(this, [tenant_1, Accept_Language_1, CartV2VoucherRequestV1_1, purgeMessages_1, nowZipCode_1, ...args_1], void 0, function* (tenant, Accept_Language, CartV2VoucherRequestV1, purgeMessages, nowZipCode, options = {}) {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('cartV2TenantVoucherPost', 'tenant', tenant);
            // verify required parameter 'Accept_Language' is not null or undefined
            assertParamExists('cartV2TenantVoucherPost', 'Accept_Language', Accept_Language);
            // verify required parameter 'CartV2VoucherRequestV1' is not null or undefined
            assertParamExists('cartV2TenantVoucherPost', 'CartV2VoucherRequestV1', CartV2VoucherRequestV1);
            const localVarPath = `/cart/v2/{tenant}/voucher`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (purgeMessages !== undefined) {
                localVarQueryParameter['purgeMessages'] = purgeMessages;
            }
            if (nowZipCode !== undefined) {
                localVarQueryParameter['nowZipCode'] = nowZipCode;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            if (Accept_Language != null) {
                localVarHeaderParameter['Accept-Language'] = String(Accept_Language);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(CartV2VoucherRequestV1, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} tenant
         * @param {string} voucherCode
         * @param {string} Accept_Language
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        cartV2TenantVoucherVoucherCodeDelete: (tenant_1, voucherCode_1, Accept_Language_1, ...args_1) => __awaiter(this, [tenant_1, voucherCode_1, Accept_Language_1, ...args_1], void 0, function* (tenant, voucherCode, Accept_Language, options = {}) {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('cartV2TenantVoucherVoucherCodeDelete', 'tenant', tenant);
            // verify required parameter 'voucherCode' is not null or undefined
            assertParamExists('cartV2TenantVoucherVoucherCodeDelete', 'voucherCode', voucherCode);
            // verify required parameter 'Accept_Language' is not null or undefined
            assertParamExists('cartV2TenantVoucherVoucherCodeDelete', 'Accept_Language', Accept_Language);
            const localVarPath = `/cart/v2/{tenant}/voucher/{voucherCode}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"voucherCode"}}`, encodeURIComponent(String(voucherCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (Accept_Language != null) {
                localVarHeaderParameter['Accept-Language'] = String(Accept_Language);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * CartControllerV2Api - functional programming interface
 * @export
 */
export const CartControllerV2ApiFp = function (configuration) {
    const localVarAxiosParamCreator = CartControllerV2ApiAxiosParamCreator(configuration);
    return {
        /**
         * Endpoint to delete the existing cart, if it exists
         * @param {string} tenant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartV2TenantDelete(tenant, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.cartV2TenantDelete(tenant, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['CartControllerV2Api.cartV2TenantDelete']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} tenant
         * @param {string} hashedToken
         * @param {string} Accept_Language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartV2TenantEntriesERxHashedTokenDelete(tenant, hashedToken, Accept_Language, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.cartV2TenantEntriesERxHashedTokenDelete(tenant, hashedToken, Accept_Language, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['CartControllerV2Api.cartV2TenantEntriesERxHashedTokenDelete']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * create or update eRx entries providing eRx hashedTokens
         * @param {string} tenant
         * @param {string} Accept_Language
         * @param {Array<string>} request_body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartV2TenantEntriesERxPost(tenant, Accept_Language, request_body, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.cartV2TenantEntriesERxPost(tenant, Accept_Language, request_body, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['CartControllerV2Api.cartV2TenantEntriesERxPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * replace eRx entry providing eRx hashedTokens and preferred pzn
         * @param {string} tenant
         * @param {string} Accept_Language
         * @param {CartV2TenantEntriesERxReplacePutRequest} CartV2TenantEntriesERxReplacePutRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartV2TenantEntriesERxReplacePut(tenant, Accept_Language, CartV2TenantEntriesERxReplacePutRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.cartV2TenantEntriesERxReplacePut(tenant, Accept_Language, CartV2TenantEntriesERxReplacePutRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['CartControllerV2Api.cartV2TenantEntriesERxReplacePut']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * create multiple cartEntries
         * @param {string} tenant
         * @param {string} Accept_Language
         * @param {CartV2CartEntriesRequestV1} CartV2CartEntriesRequestV1
         * @param {boolean} [purgeMessages]
         * @param {string} [nowZipCode]
         * @param {boolean} [isNowSelected]
         * @param {string} [slotId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartV2TenantEntriesPost(tenant, Accept_Language, CartV2CartEntriesRequestV1, purgeMessages, nowZipCode, isNowSelected, slotId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.cartV2TenantEntriesPost(tenant, Accept_Language, CartV2CartEntriesRequestV1, purgeMessages, nowZipCode, isNowSelected, slotId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['CartControllerV2Api.cartV2TenantEntriesPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} tenant
         * @param {string} offerId
         * @param {string} Accept_Language
         * @param {string} prescriptionType
         * @param {string} [nowZipCode]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        cartV2TenantEntryOfferIdDelete(tenant, offerId, Accept_Language, prescriptionType, nowZipCode, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.cartV2TenantEntryOfferIdDelete(tenant, offerId, Accept_Language, prescriptionType, nowZipCode, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['CartControllerV2Api.cartV2TenantEntryOfferIdDelete']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * create or update cartEntry
         * @param {string} tenant
         * @param {string} Accept_Language
         * @param {CartV2CartEntryRequestV1} CartV2CartEntryRequestV1
         * @param {boolean} [purgeMessages]
         * @param {string} [nowZipCode]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        cartV2TenantEntryPost(tenant, Accept_Language, CartV2CartEntryRequestV1, purgeMessages, nowZipCode, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.cartV2TenantEntryPost(tenant, Accept_Language, CartV2CartEntryRequestV1, purgeMessages, nowZipCode, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['CartControllerV2Api.cartV2TenantEntryPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * replace cartEntry
         * @param {string} tenant
         * @param {string} Accept_Language
         * @param {CartV2CartReplaceEntryRequestV1} CartV2CartReplaceEntryRequestV1
         * @param {boolean} [purgeMessages]
         * @param {string} [nowZipCode]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        cartV2TenantEntryReplacePost(tenant, Accept_Language, CartV2CartReplaceEntryRequestV1, purgeMessages, nowZipCode, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.cartV2TenantEntryReplacePost(tenant, Accept_Language, CartV2CartReplaceEntryRequestV1, purgeMessages, nowZipCode, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['CartControllerV2Api.cartV2TenantEntryReplacePost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get new or existing cart for customer (including guests)
         * @param {string} tenant
         * @param {string} Accept_Language
         * @param {boolean} [purgeMessages]
         * @param {string} [nowZipCode]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        cartV2TenantGet(tenant, Accept_Language, purgeMessages, nowZipCode, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.cartV2TenantGet(tenant, Accept_Language, purgeMessages, nowZipCode, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['CartControllerV2Api.cartV2TenantGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Provides information about the cart data
         * @param {string} tenant
         * @param {string} Accept_Language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartV2TenantMetadataGet(tenant, Accept_Language, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.cartV2TenantMetadataGet(tenant, Accept_Language, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['CartControllerV2Api.cartV2TenantMetadataGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get new or existing cart for customer (including guests) - miniature format
         * @param {string} tenant
         * @param {string} Accept_Language
         * @param {boolean} [disableRefresh]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        cartV2TenantMinicartGet(tenant, Accept_Language, disableRefresh, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.cartV2TenantMinicartGet(tenant, Accept_Language, disableRefresh, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['CartControllerV2Api.cartV2TenantMinicartGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Updates the collectiveOrder or prescriptionFollows status for the customer (including guests)
         * @param {string} tenant
         * @param {string} Accept_Language
         * @param {CartV2TenantPutRequest} CartV2TenantPutRequest
         * @param {string} [nowZipCode]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        cartV2TenantPut(tenant, Accept_Language, CartV2TenantPutRequest, nowZipCode, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.cartV2TenantPut(tenant, Accept_Language, CartV2TenantPutRequest, nowZipCode, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['CartControllerV2Api.cartV2TenantPut']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} tenant
         * @param {string} Accept_Language
         * @param {boolean} [purgeMessages]
         * @param {string} [nowZipCode]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        cartV2TenantRedpointsDelete(tenant, Accept_Language, purgeMessages, nowZipCode, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.cartV2TenantRedpointsDelete(tenant, Accept_Language, purgeMessages, nowZipCode, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['CartControllerV2Api.cartV2TenantRedpointsDelete']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} tenant
         * @param {string} Accept_Language
         * @param {CartV2RedPointsRequestV1} CartV2RedPointsRequestV1
         * @param {boolean} [purgeMessages]
         * @param {string} [nowZipCode]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        cartV2TenantRedpointsPost(tenant, Accept_Language, CartV2RedPointsRequestV1, purgeMessages, nowZipCode, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.cartV2TenantRedpointsPost(tenant, Accept_Language, CartV2RedPointsRequestV1, purgeMessages, nowZipCode, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['CartControllerV2Api.cartV2TenantRedpointsPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} tenant
         * @param {string} Accept_Language
         * @param {CartV2VoucherRequestV1} CartV2VoucherRequestV1
         * @param {boolean} [purgeMessages]
         * @param {string} [nowZipCode]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        cartV2TenantVoucherPost(tenant, Accept_Language, CartV2VoucherRequestV1, purgeMessages, nowZipCode, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.cartV2TenantVoucherPost(tenant, Accept_Language, CartV2VoucherRequestV1, purgeMessages, nowZipCode, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['CartControllerV2Api.cartV2TenantVoucherPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} tenant
         * @param {string} voucherCode
         * @param {string} Accept_Language
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        cartV2TenantVoucherVoucherCodeDelete(tenant, voucherCode, Accept_Language, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.cartV2TenantVoucherVoucherCodeDelete(tenant, voucherCode, Accept_Language, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['CartControllerV2Api.cartV2TenantVoucherVoucherCodeDelete']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * CartControllerV2Api - factory interface
 * @export
 */
export const CartControllerV2ApiFactory = function (configuration, basePath, axios) {
    const localVarFp = CartControllerV2ApiFp(configuration);
    return {
        /**
         * Endpoint to delete the existing cart, if it exists
         * @param {CartControllerV2ApiCartV2TenantDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartV2TenantDelete(requestParameters, options) {
            return localVarFp.cartV2TenantDelete(requestParameters.tenant, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CartControllerV2ApiCartV2TenantEntriesERxHashedTokenDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartV2TenantEntriesERxHashedTokenDelete(requestParameters, options) {
            return localVarFp.cartV2TenantEntriesERxHashedTokenDelete(requestParameters.tenant, requestParameters.hashedToken, requestParameters.Accept_Language, options).then((request) => request(axios, basePath));
        },
        /**
         * create or update eRx entries providing eRx hashedTokens
         * @param {CartControllerV2ApiCartV2TenantEntriesERxPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartV2TenantEntriesERxPost(requestParameters, options) {
            return localVarFp.cartV2TenantEntriesERxPost(requestParameters.tenant, requestParameters.Accept_Language, requestParameters.request_body, options).then((request) => request(axios, basePath));
        },
        /**
         * replace eRx entry providing eRx hashedTokens and preferred pzn
         * @param {CartControllerV2ApiCartV2TenantEntriesERxReplacePutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartV2TenantEntriesERxReplacePut(requestParameters, options) {
            return localVarFp.cartV2TenantEntriesERxReplacePut(requestParameters.tenant, requestParameters.Accept_Language, requestParameters.CartV2TenantEntriesERxReplacePutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * create multiple cartEntries
         * @param {CartControllerV2ApiCartV2TenantEntriesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartV2TenantEntriesPost(requestParameters, options) {
            return localVarFp.cartV2TenantEntriesPost(requestParameters.tenant, requestParameters.Accept_Language, requestParameters.CartV2CartEntriesRequestV1, requestParameters.purgeMessages, requestParameters.nowZipCode, requestParameters.isNowSelected, requestParameters.slotId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CartControllerV2ApiCartV2TenantEntryOfferIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        cartV2TenantEntryOfferIdDelete(requestParameters, options) {
            return localVarFp.cartV2TenantEntryOfferIdDelete(requestParameters.tenant, requestParameters.offerId, requestParameters.Accept_Language, requestParameters.prescriptionType, requestParameters.nowZipCode, options).then((request) => request(axios, basePath));
        },
        /**
         * create or update cartEntry
         * @param {CartControllerV2ApiCartV2TenantEntryPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        cartV2TenantEntryPost(requestParameters, options) {
            return localVarFp.cartV2TenantEntryPost(requestParameters.tenant, requestParameters.Accept_Language, requestParameters.CartV2CartEntryRequestV1, requestParameters.purgeMessages, requestParameters.nowZipCode, options).then((request) => request(axios, basePath));
        },
        /**
         * replace cartEntry
         * @param {CartControllerV2ApiCartV2TenantEntryReplacePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        cartV2TenantEntryReplacePost(requestParameters, options) {
            return localVarFp.cartV2TenantEntryReplacePost(requestParameters.tenant, requestParameters.Accept_Language, requestParameters.CartV2CartReplaceEntryRequestV1, requestParameters.purgeMessages, requestParameters.nowZipCode, options).then((request) => request(axios, basePath));
        },
        /**
         * Get new or existing cart for customer (including guests)
         * @param {CartControllerV2ApiCartV2TenantGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        cartV2TenantGet(requestParameters, options) {
            return localVarFp.cartV2TenantGet(requestParameters.tenant, requestParameters.Accept_Language, requestParameters.purgeMessages, requestParameters.nowZipCode, options).then((request) => request(axios, basePath));
        },
        /**
         * Provides information about the cart data
         * @param {CartControllerV2ApiCartV2TenantMetadataGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartV2TenantMetadataGet(requestParameters, options) {
            return localVarFp.cartV2TenantMetadataGet(requestParameters.tenant, requestParameters.Accept_Language, options).then((request) => request(axios, basePath));
        },
        /**
         * Get new or existing cart for customer (including guests) - miniature format
         * @param {CartControllerV2ApiCartV2TenantMinicartGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        cartV2TenantMinicartGet(requestParameters, options) {
            return localVarFp.cartV2TenantMinicartGet(requestParameters.tenant, requestParameters.Accept_Language, requestParameters.disableRefresh, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the collectiveOrder or prescriptionFollows status for the customer (including guests)
         * @param {CartControllerV2ApiCartV2TenantPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        cartV2TenantPut(requestParameters, options) {
            return localVarFp.cartV2TenantPut(requestParameters.tenant, requestParameters.Accept_Language, requestParameters.CartV2TenantPutRequest, requestParameters.nowZipCode, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CartControllerV2ApiCartV2TenantRedpointsDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        cartV2TenantRedpointsDelete(requestParameters, options) {
            return localVarFp.cartV2TenantRedpointsDelete(requestParameters.tenant, requestParameters.Accept_Language, requestParameters.purgeMessages, requestParameters.nowZipCode, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CartControllerV2ApiCartV2TenantRedpointsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        cartV2TenantRedpointsPost(requestParameters, options) {
            return localVarFp.cartV2TenantRedpointsPost(requestParameters.tenant, requestParameters.Accept_Language, requestParameters.CartV2RedPointsRequestV1, requestParameters.purgeMessages, requestParameters.nowZipCode, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CartControllerV2ApiCartV2TenantVoucherPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        cartV2TenantVoucherPost(requestParameters, options) {
            return localVarFp.cartV2TenantVoucherPost(requestParameters.tenant, requestParameters.Accept_Language, requestParameters.CartV2VoucherRequestV1, requestParameters.purgeMessages, requestParameters.nowZipCode, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CartControllerV2ApiCartV2TenantVoucherVoucherCodeDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        cartV2TenantVoucherVoucherCodeDelete(requestParameters, options) {
            return localVarFp.cartV2TenantVoucherVoucherCodeDelete(requestParameters.tenant, requestParameters.voucherCode, requestParameters.Accept_Language, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * CartControllerV2Api - object-oriented interface
 * @export
 * @class CartControllerV2Api
 * @extends {BaseAPI}
 */
export class CartControllerV2Api extends BaseAPI {
    /**
     * Endpoint to delete the existing cart, if it exists
     * @param {CartControllerV2ApiCartV2TenantDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartControllerV2Api
     */
    cartV2TenantDelete(requestParameters, options) {
        return CartControllerV2ApiFp(this.configuration).cartV2TenantDelete(requestParameters.tenant, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CartControllerV2ApiCartV2TenantEntriesERxHashedTokenDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartControllerV2Api
     */
    cartV2TenantEntriesERxHashedTokenDelete(requestParameters, options) {
        return CartControllerV2ApiFp(this.configuration).cartV2TenantEntriesERxHashedTokenDelete(requestParameters.tenant, requestParameters.hashedToken, requestParameters.Accept_Language, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * create or update eRx entries providing eRx hashedTokens
     * @param {CartControllerV2ApiCartV2TenantEntriesERxPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartControllerV2Api
     */
    cartV2TenantEntriesERxPost(requestParameters, options) {
        return CartControllerV2ApiFp(this.configuration).cartV2TenantEntriesERxPost(requestParameters.tenant, requestParameters.Accept_Language, requestParameters.request_body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * replace eRx entry providing eRx hashedTokens and preferred pzn
     * @param {CartControllerV2ApiCartV2TenantEntriesERxReplacePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartControllerV2Api
     */
    cartV2TenantEntriesERxReplacePut(requestParameters, options) {
        return CartControllerV2ApiFp(this.configuration).cartV2TenantEntriesERxReplacePut(requestParameters.tenant, requestParameters.Accept_Language, requestParameters.CartV2TenantEntriesERxReplacePutRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * create multiple cartEntries
     * @param {CartControllerV2ApiCartV2TenantEntriesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartControllerV2Api
     */
    cartV2TenantEntriesPost(requestParameters, options) {
        return CartControllerV2ApiFp(this.configuration).cartV2TenantEntriesPost(requestParameters.tenant, requestParameters.Accept_Language, requestParameters.CartV2CartEntriesRequestV1, requestParameters.purgeMessages, requestParameters.nowZipCode, requestParameters.isNowSelected, requestParameters.slotId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CartControllerV2ApiCartV2TenantEntryOfferIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof CartControllerV2Api
     */
    cartV2TenantEntryOfferIdDelete(requestParameters, options) {
        return CartControllerV2ApiFp(this.configuration).cartV2TenantEntryOfferIdDelete(requestParameters.tenant, requestParameters.offerId, requestParameters.Accept_Language, requestParameters.prescriptionType, requestParameters.nowZipCode, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * create or update cartEntry
     * @param {CartControllerV2ApiCartV2TenantEntryPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof CartControllerV2Api
     */
    cartV2TenantEntryPost(requestParameters, options) {
        return CartControllerV2ApiFp(this.configuration).cartV2TenantEntryPost(requestParameters.tenant, requestParameters.Accept_Language, requestParameters.CartV2CartEntryRequestV1, requestParameters.purgeMessages, requestParameters.nowZipCode, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * replace cartEntry
     * @param {CartControllerV2ApiCartV2TenantEntryReplacePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof CartControllerV2Api
     */
    cartV2TenantEntryReplacePost(requestParameters, options) {
        return CartControllerV2ApiFp(this.configuration).cartV2TenantEntryReplacePost(requestParameters.tenant, requestParameters.Accept_Language, requestParameters.CartV2CartReplaceEntryRequestV1, requestParameters.purgeMessages, requestParameters.nowZipCode, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get new or existing cart for customer (including guests)
     * @param {CartControllerV2ApiCartV2TenantGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof CartControllerV2Api
     */
    cartV2TenantGet(requestParameters, options) {
        return CartControllerV2ApiFp(this.configuration).cartV2TenantGet(requestParameters.tenant, requestParameters.Accept_Language, requestParameters.purgeMessages, requestParameters.nowZipCode, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Provides information about the cart data
     * @param {CartControllerV2ApiCartV2TenantMetadataGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartControllerV2Api
     */
    cartV2TenantMetadataGet(requestParameters, options) {
        return CartControllerV2ApiFp(this.configuration).cartV2TenantMetadataGet(requestParameters.tenant, requestParameters.Accept_Language, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get new or existing cart for customer (including guests) - miniature format
     * @param {CartControllerV2ApiCartV2TenantMinicartGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof CartControllerV2Api
     */
    cartV2TenantMinicartGet(requestParameters, options) {
        return CartControllerV2ApiFp(this.configuration).cartV2TenantMinicartGet(requestParameters.tenant, requestParameters.Accept_Language, requestParameters.disableRefresh, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Updates the collectiveOrder or prescriptionFollows status for the customer (including guests)
     * @param {CartControllerV2ApiCartV2TenantPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof CartControllerV2Api
     */
    cartV2TenantPut(requestParameters, options) {
        return CartControllerV2ApiFp(this.configuration).cartV2TenantPut(requestParameters.tenant, requestParameters.Accept_Language, requestParameters.CartV2TenantPutRequest, requestParameters.nowZipCode, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CartControllerV2ApiCartV2TenantRedpointsDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof CartControllerV2Api
     */
    cartV2TenantRedpointsDelete(requestParameters, options) {
        return CartControllerV2ApiFp(this.configuration).cartV2TenantRedpointsDelete(requestParameters.tenant, requestParameters.Accept_Language, requestParameters.purgeMessages, requestParameters.nowZipCode, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CartControllerV2ApiCartV2TenantRedpointsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof CartControllerV2Api
     */
    cartV2TenantRedpointsPost(requestParameters, options) {
        return CartControllerV2ApiFp(this.configuration).cartV2TenantRedpointsPost(requestParameters.tenant, requestParameters.Accept_Language, requestParameters.CartV2RedPointsRequestV1, requestParameters.purgeMessages, requestParameters.nowZipCode, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CartControllerV2ApiCartV2TenantVoucherPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof CartControllerV2Api
     */
    cartV2TenantVoucherPost(requestParameters, options) {
        return CartControllerV2ApiFp(this.configuration).cartV2TenantVoucherPost(requestParameters.tenant, requestParameters.Accept_Language, requestParameters.CartV2VoucherRequestV1, requestParameters.purgeMessages, requestParameters.nowZipCode, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CartControllerV2ApiCartV2TenantVoucherVoucherCodeDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof CartControllerV2Api
     */
    cartV2TenantVoucherVoucherCodeDelete(requestParameters, options) {
        return CartControllerV2ApiFp(this.configuration).cartV2TenantVoucherVoucherCodeDelete(requestParameters.tenant, requestParameters.voucherCode, requestParameters.Accept_Language, options).then((request) => request(this.axios, this.basePath));
    }
}
